import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';

import {
  ConnectorDomRendererExtension,
  ConnectorElementRendererExtension,
} from './renderer';
import { ConnectorElementView } from './view/view';

export function registerConnectorViewing(context: ViewExtensionContext) {
  context.register(ConnectorElementView);
  context.register(ConnectorElementRendererExtension);
  context.register(ConnectorDomRendererExtension);
}
export class ConnectorViewingExtension extends ViewExtensionProvider {
  override name = 'connector-viewing';
  override setup(context: ViewExtensionContext) {
    super.setup(context);
    registerConnectorViewing(context);
  }
}
